import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';
import TableDescriptors from '../../../definitions/tableDescriptors';

import GlassPopup from '../common/interface/glassPopup';
import ObjectDefinitionEditor from '../common/inputs/objectDefinitionEditor';
import ErrorFeedback from '../common/feedback/errorFeedback';
import FieldInfo from '../common/inputs/fieldInfo';

const NotificationDetailPopup = props => {
  const {
    handleShowPopup,
    fullLoading,
    notificationData,
    notificationStatus,
    popupState,
    handleDownloadNotificationFile,
    handleDeleteNotificationData,
    handleStopProcess,
    handleCalculationDetailPopup,
    handleErrorDetailPopup
  } = props;
  let showStopProcessButton = false
  if(notificationData && notificationData.process_state==Constants.notifications.PROCESSING_STATE &&
      (notificationData.code == Constants.notifications.CALCULATION_TYPE || 
      notificationData.code == Constants.notifications.METRIC_IMPORT_TYPE || 
      notificationData.code == Constants.notifications.GENERATE_REPORT_FILES_TYPE ||
      notificationData.code == Constants.notifications.GENERATE_VIRTUAL_METRICS_TYPE ||
      notificationData.code == Constants.notifications.SEND_REPORT_FILES_MAILS_TYPE ||
      notificationData.code == Constants.notifications.EXPORT_REPORT_FILES_ENDPOINT_CONNECTOR_TYPE ||
      notificationData.code == Constants.notifications.EXPORT_CALCULATIONS_ENDPOINT_CONNECTOR_TYPE)
    ) {
    showStopProcessButton = true;
  }

  let grouped_errors_list = []
  if(notificationData.additional_data && notificationData.additional_data.errors_detail && notificationData.code == Constants.notifications.METRIC_IMPORT_TYPE) {
    let errors_dictionary = {}
    let simple_text_errors = []
    notificationData.additional_data.errors_detail.map(error => {
      if(typeof error === 'object'){
        if(error.detail && error.detail.dimension_values) {
          error.detail.dimension_values.map(dimension_error_object => {
            let error_type = dimension_error_object.error
            let dimension_name = dimension_error_object.dimension_name
            
            switch(error_type) {
              case "blank":
                if(!errors_dictionary[error_type]) {
                  errors_dictionary[error_type] = {}
                }
                if(!errors_dictionary[error_type][dimension_name]){
                  errors_dictionary[error_type][dimension_name] = []
                }
                errors_dictionary[error_type][dimension_name].push({
                  row: error.row,
                  dataType: "dimension",
                })
                break;
              case "invalid":
              case "empty_value":
                if(!errors_dictionary[error_type]){
                  errors_dictionary[error_type] = []
                }
                if(!errors_dictionary[error_type].includes(error.row)){
                  errors_dictionary[error_type].push(error.row)
                }
                break;
              case "invalid_type":
                if(!errors_dictionary[error_type]) {
                  errors_dictionary[error_type] = {}
                }
                if(!errors_dictionary[error_type][dimension_name]){
                  errors_dictionary[error_type][dimension_name] = []
                }
                errors_dictionary[error_type][dimension_name].push({
                  row: error.row,
                  value: dimension_error_object.error_value,
                  dataType: "dimension",
                })
                break;                
              case "taken":
                if(!errors_dictionary[error_type]) {
                  errors_dictionary[error_type] = {}
                }
                let metric_name = dimension_error_object.metric_name
                if(!errors_dictionary[error_type][metric_name]){
                  errors_dictionary[error_type][metric_name] = []
                }
                errors_dictionary[error_type][metric_name].push({
                  row: error.row,
                  value: metric_name,
                  dataType: "dimension",
                })
                break;
            }
          })
        }

        if(error.detail && error.detail.value){
          error.detail.value.map(metric_error_object => {
            let error_type = metric_error_object.error
            let metric_name = metric_error_object.metric_name
            if(!errors_dictionary[error_type]) {
              errors_dictionary[error_type] = {}
            }
            switch (error_type) {
              case "blank":
                if(!errors_dictionary[error_type][metric_name]){
                  errors_dictionary[error_type][metric_name] = []
                }
                errors_dictionary[error_type][metric_name].push({
                  row: error.row,
                  dataType: "metric",
                })
                break;
              case "invalid_type":
                if(!errors_dictionary[error_type][metric_name]){
                  errors_dictionary[error_type][metric_name] = []
                }
                errors_dictionary[error_type][metric_name].push({
                  row: error.row,
                  value: metric_error_object.error_value,
                  dataType: "metric",
                })
                break;
              case "invalid_type_with_dimension":
                if(!errors_dictionary[error_type][metric_name]){
                  errors_dictionary[error_type][metric_name] = []
                }
                errors_dictionary[error_type][metric_name].push({
                  row: error.row,
                  value: metric_error_object.error_value,
                  dataType: "metric",
                  dimension_name: metric_error_object.dimension_name,
                })
            }
          })
        }        
      }
      else{
        simple_text_errors.push(error)
      }
    })
    
    Object.keys(errors_dictionary).map(key => {
      switch (key) {
        case "empty_value":
        case "invalid":
          let errorDataType = "dimension"
          if(errors_dictionary[key].length > 1){
            grouped_errors_list.push({
              error_type: key,
              errors: [{message: intl.formatMessage(
                {id: "notifications.importMetricError.detailedErrorText." + errorDataType  + "." + key},
                {rows: errors_dictionary[key].join(", ")})
            }],
              group_error_text: intl.formatMessage(
                {id: "notifications.importMetricError.groupedErrorText." + errorDataType + "." + key},
                {rowsAmount: errors_dictionary[key].length}),
            })
          }
          else{
            simple_text_errors.push(intl.formatMessage(
              {id: "notifications.importMetricError.singularErrorText" + "." + errorDataType + "." + key},
              {rowNumber: errors_dictionary[key][0]}
            ))
          }
          break;
        case "invalid_type":
        case "blank":
          Object.keys(errors_dictionary[key]).map(dimension_or_metric_name => {    
            let condensed_errors_dictionary = {}
            let errorDataType = errors_dictionary[key][dimension_or_metric_name][0].dataType
            let total_error_rows = 0
            let error_amount = 0
            errors_dictionary[key][dimension_or_metric_name].map(error => {
              if(!condensed_errors_dictionary[error.value]){
                condensed_errors_dictionary[error.value] = {
                  rows: [],
                  value: error.value,
                  // message: "Valor inválido: '" + error.value + "'",
                  dataType: error.dataType,
                }
              }
              error_amount += 1
              if(!condensed_errors_dictionary[error.value].rows.includes(error.row)){                
                condensed_errors_dictionary[error.value].rows.push(error.row)   
                total_error_rows += 1       
              }
            })

            condensed_errors_dictionary = Object.values(condensed_errors_dictionary)
            condensed_errors_dictionary.forEach(error_hash => {
              error_hash.message = intl.formatMessage(
                {id: "notifications.importMetricError.detailedErrorText." + errorDataType  + "." + key},
                {errorValue: "'"+error_hash.value+"'", rowsAmount: error_hash.rows.length})
            })
    
            if(error_amount > 1){
              grouped_errors_list.push({
                error_type: key,
                dimension_or_metric_name: dimension_or_metric_name,
                errors: condensed_errors_dictionary,
                group_error_text: intl.formatMessage(
                  {id: "notifications.importMetricError.groupedErrorText." + errorDataType + "." + key},
                  {itemName: "'"+dimension_or_metric_name+"'", rowsAmount: total_error_rows}),
              })
            }
            else{
              simple_text_errors.push(intl.formatMessage(
                {id: "notifications.importMetricError.singularErrorText" + "." + errorDataType + "." + key},
                {itemName: "'"+dimension_or_metric_name+"'", errorValue: "'"+condensed_errors_dictionary[0].value+"'", rowNumber: errors_dictionary[key][dimension_or_metric_name][0].row}
              ))
            }
          })          
          break;
        case "taken":
          Object.keys(errors_dictionary[key]).map(metric_name => {    
            let condensed_errors_dictionary = {}
            let errorDataType = errors_dictionary[key][metric_name][0].dataType
            let total_error_rows = 0
            let error_amount = 0
            errors_dictionary[key][metric_name].map(error => {
              if(!condensed_errors_dictionary[error.value]){
                condensed_errors_dictionary[error.value] = {
                  rows: [],
                  value: error.value,
                  dataType: error.dataType,
                }
              }
              error_amount += 1
              if(!condensed_errors_dictionary[error.value].rows.includes(error.row)){                
                condensed_errors_dictionary[error.value].rows.push(error.row)
                total_error_rows += 1          
              }       
            })
    
            condensed_errors_dictionary = Object.values(condensed_errors_dictionary)[0]
            condensed_errors_dictionary.message = intl.formatMessage(
              {id: "notifications.importMetricError.detailedErrorText." + errorDataType  + "." + key},
              {rows: condensed_errors_dictionary.rows.join(", ")}
            )            
    
            if(error_amount > 1){
              grouped_errors_list.push({
                error_type: key,
                dimension_or_metric_name: metric_name,
                errors: [condensed_errors_dictionary],
                group_error_text: intl.formatMessage(
                  {id: "notifications.importMetricError.groupedErrorText." + errorDataType + "." + key},
                  {itemName: "'"+metric_name+"'", rowsAmount: total_error_rows}),
              })
            }
            else{
              simple_text_errors.push(intl.formatMessage(
                {id: "notifications.importMetricError.singularErrorText" + "." + errorDataType + "." + key},
                {itemName: "'"+metric_name+"'", rowNumber: condensed_errors_dictionary.rows[0]}
              ))
            }
          }) 
          break;
        case "invalid_type_with_dimension":
          Object.keys(errors_dictionary[key]).map(metric_name => {
            let condensed_errors_dictionary = {}
            let errorDataType = errors_dictionary[key][metric_name][0].dataType
            let error_amount = 0
            let total_error_rows = 0
            errors_dictionary[key][metric_name].map(error => {
              if(!condensed_errors_dictionary[error.value]){
                condensed_errors_dictionary[error.value] = {
                  rows: [],
                  value: error.value,
                  dataType: error.dataType,
                  dimensionName: error.dimension_name,
                }
              }
              error_amount += 1
              if(!condensed_errors_dictionary[error.value].rows.includes(error.row)){                
                condensed_errors_dictionary[error.value].rows.push(error.row)
                total_error_rows += 1          
              }     
            })
    
            condensed_errors_dictionary = Object.values(condensed_errors_dictionary)
            condensed_errors_dictionary.forEach(error_hash => {
              error_hash.message = intl.formatMessage(
                {id: "notifications.importMetricError.detailedErrorText." + errorDataType  + "." + key},
                {errorValue: "'"+error_hash.value+"'", rowsAmount: error_hash.rows.length})
            })
    
            if(error_amount > 1){
              grouped_errors_list.push({
                error_type: key,
                dimension_or_metric_name: metric_name,
                errors: condensed_errors_dictionary,
                group_error_text: intl.formatMessage(
                  {id: "notifications.importMetricError.groupedErrorText." + errorDataType + "." + key},
                  {metricName: "'"+metric_name+"'", dimensionName: errors_dictionary[key][metric_name][0].dimension_name, rowsAmount: total_error_rows}),
              })
            }
            else{
              simple_text_errors.push(intl.formatMessage(
                {id: "notifications.importMetricError.singularErrorText" + "." + errorDataType + "." + key},
                {metricName: "'"+metric_name+"'", dimensionName: "'"+errors_dictionary[key][metric_name][0].dimension_name+"'",
                  rowNumber: condensed_errors_dictionary[0].rows[0] , errorValue: "'"+condensed_errors_dictionary[0].value+"'"}
              ))
            }
          })
          break;
      }
    })

    grouped_errors_list = grouped_errors_list.concat(simple_text_errors)
  }

  return (
    <GlassPopup
      className={"form_popup notifications_detail_popup" + (notificationStatus==404 ? " notification_not_found" : "")}
      title={TableDescriptors.notificationsList.entityNameSingular + ": " + (notificationData.code ? LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "notifications.codes." + notificationData.code})) : "")}
      type={Constants.interface.popup.types.LATERAL}
      handleAlternativeButton={((notificationData.process_state == Constants.notifications.SUCCESS_STATE || 
        notificationData.process_state == Constants.notifications.SUCCESS_WITH_ERRORS || 
        notificationData.process_state == Constants.notifications.STOPPED_STATE) && notificationData.code == Constants.notifications.METRIC_IMPORT_TYPE) ? handleDeleteNotificationData : (showStopProcessButton ? handleStopProcess : null)}
      alternativeButtonText={showStopProcessButton ? (<FormattedMessage id="notifications.stopProcess.button"/>) : (<FormattedMessage id="notifications.deleteNotificationData.button"/>)}
      alternativeButtonClass="notifications_delete_data_button"
      {...props}
    >
      {notificationStatus==404 && (
         <ErrorFeedback
          status={404}
          optionalStatusErrors={{404: intl.formatMessage({ id: "notifications.deletedInfoFeedback"})}}
        />       
      )}
      {notificationData.code && (
        <div>
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.code"/>)}
            value={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( {id: "notifications.codes." + notificationData.code}))}
          />
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.detail"/>)}
            value={notificationData.detail}
          />
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.period_name"/>)}
            value={notificationData.period_name}
          />
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.created_at"/>)}
            value={FormatTooling.defaultsTextFormatTypes(notificationData.created_at,Constants.crudGenerator.dataTypes.DATETIME)}
          />
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.duration"/>)}
            value={notificationData.duration}
          />
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.process_state"/>)}
            value={(<FormattedMessage id={"notifications.process_states." + notificationData.process_state}/>)}
          />
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.process_information"/>)}
            value={notificationData.process_information}
          />
          <FieldInfo 
            label={(<FormattedMessage id="notifications.fields.job_key"/>)}
            value={notificationData.job_key}
          />
          {(notificationData.additional_data && notificationData.additional_data.errors_download_file_name) ? (
            <FieldInfo 
              label={(<FormattedMessage id="notifications.fields.erros_download_link"/>)}
              value={(<FormattedMessage id="notifications.downloadLink"/>)}
              handleLink={handleDownloadNotificationFile}
            />
          ) : (notificationData.additional_data && notificationData.additional_data.temp_download_file_name) ? (
            <FieldInfo 
              label={(<FormattedMessage id="notifications.fields.temp_download_link"/>)}
              value={(<FormattedMessage id="notifications.downloadLink"/>)}
              handleLink={handleDownloadNotificationFile}
            />
          ) : null}
          {(notificationData.process_state == Constants.notifications.INVALID_HEURISTIC_STATE) && (
            <label className="form_info">
              <FormattedMessage id={"notifications.errorsHelp2"} />
            </label>
          )}
          {(notificationData.additional_data && notificationData.additional_data.errors_detail && notificationData.code == Constants.notifications.METRIC_IMPORT_TYPE ) && (
            <label className="form_info">
              <FormattedMessage id={"notifications.errorsHelp"} />
            </label>
          )}
        </div>
      )}
      {(notificationData.additional_data && notificationData.additional_data.errors_detail && 
        notificationData.code == Constants.notifications.CALCULATION_TYPE) ? (
        <ErrorFeedback
          status={402}
          fieldErrors={{errors: notificationData.additional_data.errors_detail.map(item => {
            if(typeof item === 'object') {
              return (
                <span 
                  onClick={handleCalculationDetailPopup}
                  data-calculationid={item.root_calculation_instance_id}
                  data-errorarray={JSON.stringify(item.message)}
                  data-grouperrortext={item.group_error_text ? JSON.stringify(item.group_error_text) : ""}
                  className={"error_notification_link"}
                >
                  {item.message}
                </span>
              );
            }
            else {
              return item;
            }
          })}}
        />
        ) : (notificationData.additional_data && notificationData.additional_data.errors_detail && 
          notificationData.code == Constants.notifications.METRIC_IMPORT_TYPE) ? (
          <ErrorFeedback
            status={402}
            fieldErrors={{errors: grouped_errors_list.map(item => {
              if(typeof item === 'object') {
                return (
                  <span
                    onClick={handleErrorDetailPopup}
                    data-errorarray={JSON.stringify(item.errors)}
                    data-grouperrortext={item.group_error_text ? item.group_error_text : ""}
                    data-errornotificationcode={notificationData.code}
                    className={"error_notification_link"}
                  >
                    {" - " + (item.group_error_text ? (item.group_error_text) : item)}
                  </span>
                );
              }
              else {
                return " - " + item;
              }
            })}}
          />
      ) : (notificationData.additional_data && notificationData.additional_data.errors_detail) ? (
        <ErrorFeedback
          status={402}
          fieldErrors={{errors: notificationData.additional_data.errors_detail}}
        />
      ) : null}
    </GlassPopup>
  );
};

export default NotificationDetailPopup;



// WEBPACK FOOTER //
// ./source/client/components/dashboard/notificationDetailPopup.jsx